import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '..';
import { CONTROLLERS, ENDPOINTS } from '../../constants';
import { BillingAddress, BillingAddressListReq, Response } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class BillingAddressService {
  private api: string = CONTROLLERS.TENANTS.BILLING_ADDRESS;
  constructor(private apiService: ApiService) {}

  getPatientBillingAddress(
    patientBillingAddressListReq: BillingAddressListReq
  ): Observable<Response<BillingAddress[]>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.BILLING_ADDRESS.GET_PATIENT_BILLING_ADDRESS}`,
      patientBillingAddressListReq
    );
  }

  createPatientBillingAddress(
    createPatientBillingAddressReq: BillingAddress
  ): Observable<Response<boolean>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.BILLING_ADDRESS.CREATE_PATIENT_BILLING_ADDRESS}`,
      createPatientBillingAddressReq
    );
  }
}
